export const FORM_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const FORM_STATUS_DISPLAY = {
  [FORM_STATUS.NOT_STARTED]: 'Not Started',
  [FORM_STATUS.DRAFT]: 'Draft',
  [FORM_STATUS.SUBMITTED]: 'Submitted',
  [FORM_STATUS.APPROVED]: 'Approved',
  [FORM_STATUS.REJECTED]: 'Rejected',
};

export const FORM_ACTION = {
  START: 'Start Form',
  CONTINUE: 'Continue',
  PREVIEW: 'Preview',
  EDIT_RESUBMIT: 'Edit & Resubmit',
};

export const FORM_CATEGORY = {
  JOINING: 'JOINING',
  PENSION: 'PENSION',
};

export const STATUS_COLORS = {
  [FORM_STATUS.NOT_STARTED]: 'bg-gray-100 text-gray-700 border border-gray-200',
  [FORM_STATUS.DRAFT]: 'bg-orange-100 text-orange-700 border border-orange-200',
  [FORM_STATUS.SUBMITTED]: 'bg-blue-100 text-blue-700 border border-blue-200',
  [FORM_STATUS.APPROVED]: 'bg-green-100 text-green-700 border border-green-200',
  [FORM_STATUS.REJECTED]: 'bg-red-100 text-red-700 border border-red-200',
};
